import { useInsurerMutation } from '@/core/domain/people/Insurers/Insurers.hooks';
import { Insurer } from '@/core/domain/people/Insurers/Insurers.types';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { Form, InputProps } from 'antd';
import { useEffect } from 'react';
import InputSearch from '../InputSearch';
import InsurersSelectedModal from '../InsurersSelectedModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';

type Props = InputProps & {
  onInsurerSelect: (insurer: Insurer) => void;
  fieldNameId: string;
  buttonSearchDisabled?: boolean;
};

const InsurerInputSearch: React.FC<Props> = ({
  onInsurerSelect,
  fieldNameId,
  buttonSearchDisabled = false,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();
  const form = Form.useFormInstance();
  const customerId = Form.useWatch(fieldNameId, form);

  const { mutateAsync: getInsurer, isLoading } = useInsurerMutation();

  useEffect(() => {
    if (customerId && hasPermissions([Authorities.REGISTER_INSURER_VIEW])) {
      getInsurer(customerId).then((insurer) =>
        form.setFieldValue('insurerName', insurer.name),
      );
    }
  }, [customerId]);

  return (
    <>
      <InputSearch
        {...props}
        inputProps={{ disabled: true }}
        buttonProps={{
          onClick: modalAction.open,
          loading: isLoading,
          disabled:
            !hasPermissions([Authorities.REGISTER_INSURER_VIEW]) ||
            buttonSearchDisabled,
        }}
      />

      <InsurersSelectedModal
        handleVisible={modalAction.close}
        visible={modalOpened}
        onInsurersSelect={(insurer) => {
          onInsurerSelect(insurer);
          modalAction.close();
        }}
        noSelection
      />
    </>
  );
};

export default InsurerInputSearch;
